import React from "react";
import { Card, CardTitle, CardBody, Button, Spinner } from "reactstrap";
import livenessNoVideo from "@/assets/img/liveness-no-video.png";
import livenessError from "@/assets/img/liveness-error.svg";

export default function Video({
  src,
  name,
  state = "ready",
  onRetry,
  ...rest
}) {
  const renderBody = () => {
    switch (state) {
      case "loading":
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#444444",
              height: "400px",
            }}>
            <Spinner
              color="white"
              style={{ width: "5rem", height: "5rem", borderWidth: "0.4em" }}
            />
          </div>
        );
      case "empty":
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#d8d8d8",
              height: "400px",
            }}>
            <img
              width="226px"
              height="210px"
              src={livenessNoVideo}
              alt="No liveness video provided"
            />
          </div>
        );
      case "error":
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#444444",
              height: "400px",
            }}>
            <div className="d-flex flex-column align-items-center justify-content-center text-center">
              <img
                src={livenessError}
                alt=""
                style={{
                  width: "80px",
                  marginBottom: "1.5rem",
                }}
              />
              <div className="mb-3" style={{ color: "#fff" }}>
                Failed to load liveness video
              </div>
              {onRetry && (
                <Button color="primary" size="md" onClick={onRetry}>
                  Retry
                </Button>
              )}
            </div>
          </div>
        );
      default:
        return (
          <video
            width="100%"
            style={{ aspectRatio: "1 / 1", objectFit: "cover" }}
            src={src}
            controls>
            <track kind="captions" />
          </video>
        );
    }
  };

  return (
    <Card {...rest}>
      <CardBody>
        <CardTitle style={{ marginBottom: 0 }}>{name}</CardTitle>
      </CardBody>
      {renderBody()}
    </Card>
  );
}
